import { Menu, Text, createStyles } from '@mantine/core';
import { IconSettings, IconLogout } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';
import { useUserAuth } from "../../contexts/user.context";
import { signOutUser } from '../../utils/firebase/firebase.utils';
import { useJuneProvider } from '../../contexts/analytics.context';

const useStyles = createStyles((theme) => ({
    userIcon:{
        fontSize: theme.fontSizes.md,
        background:theme.colors.dark[5],
        color:'white',
        width:'35px',
        height:'35px',
        borderRadius:'50%',
        cursor:'pointer',
        textAlign:'center',
        lineHeight:'35px',
        fontWeight:500,
    },

    dropdownTitle:{
        textOverflow:'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    }

}));



const UserMenu = ({userEmail}) => {

    const { classes } = useStyles();

    const { currentUser, setLogOutMessage } = useUserAuth();

    const analytics = useJuneProvider();

    const navigate = useNavigate();

    const signOutHandler = async () => {
        try {
            const { uid } = currentUser;
            await signOutUser();
            setLogOutMessage('You have been logged out of your account.');
            if (analytics){
                analytics.track({
                    userId: uid,
                    event: 'Signed out',
                });
            }
            navigate('/sign-in');
        } catch (error) {
            alert('There was an error signing you out. Please try again.');
        }
    }

    const nameLetter = userEmail ? userEmail[0].toUpperCase() : '';

    const userEmailToDisplay = userEmail ? userEmail : '';

    return (
        <Menu 
            shadow="md" 
            width = {200}
            position="bottom-end"
            radius = 'lg'
        >
        <Menu.Target>
            <div className = {classes.userIcon}>
                {nameLetter}
            </div>
        </Menu.Target>
        <Menu.Dropdown>
            <Menu.Label className = {classes.dropdownTitle}>{userEmailToDisplay}</Menu.Label>
            <Menu.Item 
                component = {Link} 
                to='/account' 
                icon={<IconSettings stroke= {1.5} size={20}/>}
            >    
                <Text size='md'>Manage account</Text>
            </Menu.Item>
            <Menu.Item 
                icon={<IconLogout stroke= {1.5} size={20}/>}
                onClick = {signOutHandler}
            >
                <Text size='md'>Log out</Text>
            </Menu.Item>
        </Menu.Dropdown>
        </Menu>
    );
}

export default UserMenu;